import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import size from "../Assets/Screenshot_2024-11-28_123540-removebg-preview.png";
import size1 from "../Assets/person.png";
import size2 from "../Assets/room.png";
import { baseUrl } from "../Common/data";
import useWishlist from "../hooks/useWishlist";

// Fisher-Yates shuffle function
const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

function RelatedPropertyCard({ hotels }) {
  const navigate = useNavigate();

  const { wishlistIds, isInWishlist, toggleWishlist } = useWishlist();

  const handleHotelClick = (id) => {
    window.open(`/collectiondetail/${id}`, "_blank");
  };

  const handleWishlistClick = async (e, hotelId) => {
    e.stopPropagation();
    const token = localStorage.getItem("token");
    if (!token) return alert("Please login to add to wishlist.");
    await toggleWishlist(hotelId);
  };

  return (
    <div className="trending-cards">
      {hotels.map((hotel) => (
        <div key={hotel._id}>
          <div
            className="trending-card trending-card010"
            onClick={() => handleHotelClick(hotel._id)}
          >
            <div
              className="wishlist-icon"
              onClick={(e) => handleWishlistClick(e, hotel._id)}
            >
              <i
                className={
                  isInWishlist(hotel._id) ? "bi bi-heart-fill" : "bi bi-heart"
                }
              ></i>
            </div>

            <img
              src={hotel.images.profile}
              alt={hotel.propertyName}
              className="hotel-image"
            />
            <div className="trending-text">
              <h3>{hotel.propertyName}</h3>
              <div className="trending-text-line">
                <p>
                  <i className="bi bi-geo-alt-fill"></i> {hotel.city}
                </p>
              </div>
              <div className="trending-text-line2">
                <p>
                  {/* Upto {hotel.guestCapacity} Guest
               
                </p>
                 <p>

                ✦
                </p>
                <p>
                  
                 {hotel.totalRooms} Rooms
                </p>
                  <p>

                ✦
                </p>
                <p>
                  
                 {hotel.poolSize.length} X 
                 {hotel.poolSize.breadth}
                  Pool
                </p> */}
                  {hotel?.guestCapacity} Guest ✦ {hotel?.totalRooms}{" "}
                  {hotel?.totalRoomsType === "beds" ? "Beds" : "Rooms"} ✦{" "}
                  {hotel?.poolSize?.length} X {hotel?.poolSize?.breadth} Pool
                </p>
              </div>
              <div className="trending-text-line">
                <h2>
                  ₹ {hotel?.listingprice || ""}{" "}
                  <span>
                    / {hotel?.priceType === "per_person" ? "Person" : "Night"}
                  </span>
                </h2>
                {/* {hotel.rates.length > 0 && (
                  <h2>
                    ₹ {hotel.listingprice || hotel.rates[0].weekend} <span>/ night</span>
                  </h2>
                )} */}
                <button>Book Now</button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default RelatedPropertyCard;
